import { defineComponent as c, ref as r, onMounted as d, openBlock as p, createElementBlock as i, normalizeClass as l } from "vue";
const u = /* @__PURE__ */ c({
  __name: "CarbonBadge",
  props: {
    dark: { type: Boolean, default: void 0 }
  },
  setup(s) {
    const n = s, e = window == null ? void 0 : window.matchMedia(
      "(prefers-color-scheme: dark)"
    ), t = n.dark !== void 0, o = r(
      t ? n.dark : e == null ? void 0 : e.matches
    );
    return !t && e && (e == null || e.addEventListener(
      "change",
      (a) => o.value = a.matches
    )), d(() => {
      import("./b.min-H9mQHgio.js");
    }), (a, f) => (p(), i("div", {
      id: "wcb",
      class: l([o.value ? "wcb-d" : "", "carbonbadge"])
    }, null, 2));
  }
});
export {
  u as default
};
